// extracted by mini-css-extract-plugin
module.exports = {"ticketNamePrice":"_1NHNK","description":"_3yyEP"};